<template>
	<div class="shoppingcart-alert" role="alert">
		<div class="shoppingcart-alert__wrapper">
			<svg class="icon-exclamantion-triangle" height="20" width="20">
				<use xlink:href="/assets/images/build/svg-sprite.min.svg#exclamation-triangle"></use>
			</svg>
			<div class="shoppingcart-alert__content">
				<slot></slot>
				<slot name="action"></slot>
			</div>
		</div>
	</div>
</template>
